import styled from "@emotion/styled";
import React, { memo, useEffect } from "react";
import { PageWrapper, MobBg, VideoBG, Wrapper, WrapperSec, Shadow, } from "../../Styles/style";
import S1_Header from "../MainPage/S1_Header";
import S2_Fast from "./S2_About";
import S3_Howitworks from "./S3_Tokenomics";
import S4_Howtobuy from "./S4_Howtobuy";
import S5_Chart from "./S5_Join";
import S7_Footer from "../MainPage/S7_Footer";

import Menu from "../../Components/Menu"
import VideoBg from "../../../assets/images/pehpehvod.mp4"

import Aos from "aos";
import "aos/dist/aos.css";
import Swipe from "../../Components/Swipe";


const MainPage = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <div>
      <PageWrapper>
          <Wrapper>
          <VideoBG autoPlay muted loop>
            <source src={VideoBg} />
          </VideoBG>
            <Menu />
            <S1_Header />
          </Wrapper>
            <S2_Fast />
            <S3_Howitworks />
            <Swipe scrollamount="15"/>
            <S4_Howtobuy />
            <Swipe scrollamount="13"/>
            <S5_Chart />
            <S7_Footer />
      </PageWrapper>
    </div>
  );
};

export default memo(MainPage);
